<template>
  <div class="about">
    <div class="container marketing">
      <hr class="featurette-divider">
      <div class="row">
        <div class="tab-content" id="nav-tabContent">
          <div class="tab-pane fade show active" id="list-home" role="tabpanel" aria-labelledby="list-home-list">
            <div class="container">
              <div class="row">
                <div class="row" >
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/1.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/1.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/2.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/2.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>

                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/3.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/3.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/4.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/4.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/5.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/5.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/6.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/6.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/7.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/7.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/8.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/8.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/9.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/9.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/10.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/10.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/11.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/11.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/12.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/12.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/13.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/13.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/14.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/14.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/15.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/15.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/16.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/16.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/17.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/17.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/18.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/18.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/19.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/19.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/20.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/20.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/21.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/21.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/22.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/22.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/23.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/23.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/24.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/24.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/25.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/25.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/26.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/26.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/27.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/27.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/28.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/28.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/29.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/29.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/30.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/30.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/31.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/31.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/32.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/32.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/33.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/33.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/34.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/34.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/35.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/35.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/36.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/36.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/37.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/37.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                  <div class="col-lg-3 col-md-4 col-xs-6 thumb">
                    <a class="thumbnail" href="#" data-image-id="" data-toggle="modal" data-title=""
                       data-image="images/38.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                       data-target="#image-gallery">
                      <img class="img-thumbnail"
                           src="images/38.jpg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                           alt="Another alt text">
                    </a>
                  </div>
                </div>
                <div class="modal fade" id="image-gallery" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                  <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h4 class="modal-title" id="image-gallery-title"></h4>
                        <button type="button" class="close" data-dismiss="modal">
                          <span aria-hidden="true">×</span><span class="sr-only">Close</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <img id="image-gallery-image" class="img-responsive col-md-12" src="">
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-secondary float-left" id="show-previous-image">
                          <i class="fa fa-arrow-left"></i>
                        </button>

                        <button type="button" id="show-next-image" class="btn btn-secondary float-right">
                          <i class="fa fa-arrow-right"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  mounted () {
    const galleryScript = document.createElement('script')
    galleryScript.setAttribute('src', 'js/kalalaya.js')
    galleryScript.setAttribute('id', 'galleryScript')
    document.head.appendChild(galleryScript)
  }
}
</script>
